import React from "react";
import { connect } from "react-redux";
import BambooResyncEmployee from "./bamboo-hr/BambooResyncEmployee";
import SmartPensionResyncEmployee from "./smartPension/SmartPensionResyncEmployee";

const IntegrationResyncEmployee = ({ integrations, disabled }) => {
	if (integrations?.includes("Bamboo HR")) return <BambooResyncEmployee {...{ disabled }} />;
	if (integrations?.includes("Smart Pension")) return <SmartPensionResyncEmployee {...{ disabled }} />;

	return null;
};

const mapStateToProps = (state) => {
	const integrations = Object.values(state.integration || {})?.reduce((prev, curr) => {
		Object.values(curr || {})?.map((item) => {
			if (item.name) prev.push(item.name);
		});
		return prev;
	}, []);
	return {
		integrations,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationResyncEmployee);
